module.exports = __webpack_public_path__ + "static/media/tour-reward-orange.1639468d.svg";